import { Loader2 } from "lucide-react";
import { DashboardLayout } from "@/components/layout/DashboardLayout";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useTopShopLists, useTopShopProgram } from "@/components/admin/topshop/useTopShopAdmin";
import { TopShopApplicationsTab } from "@/components/admin/topshop/TopShopApplicationsTab";
import { TopShopSponsorsTab } from "@/components/admin/topshop/TopShopSponsorsTab";
import { TopShopListsTab } from "@/components/admin/topshop/TopShopListsTab";
import { TopShopChallengesTab } from "@/components/admin/topshop/TopShopChallengesTab";
import { TopShopRegistrationTab } from "@/components/admin/topshop/TopShopRegistrationTab";
import { TopShopLeaderboardTab } from "@/components/admin/topshop/TopShopLeaderboardTab";

export default function AdminTopShop() {
  const { data: program, isLoading } = useTopShopProgram();
  const { data: lists } = useTopShopLists(program?.id);

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <h1 className="text-2xl font-bold">Top Shop Challenge</h1>
        {isLoading || !program ? (
          <div className="flex justify-center py-16"><Loader2 className="h-8 w-8 animate-spin text-primary" /></div>
        ) : (
          <Tabs defaultValue="applications">
            <div className="overflow-x-auto">
            <TabsList className="inline-flex w-max">
              <TabsTrigger value="registration">Registration</TabsTrigger>
              <TabsTrigger value="applications">Applications</TabsTrigger>
              <TabsTrigger value="challenges">Challenges</TabsTrigger>
              <TabsTrigger value="leaderboard">Leaderboard</TabsTrigger>
              <TabsTrigger value="lists">Lists</TabsTrigger>
              <TabsTrigger value="sponsors">Sponsors</TabsTrigger>
            </TabsList>
            </div>
            <TabsContent value="registration">
              <TopShopRegistrationTab />
            </TabsContent>
            <TabsContent value="applications">
              <TopShopApplicationsTab programId={program.id} lists={lists} />
            </TabsContent>
            <TabsContent value="challenges">
              <TopShopChallengesTab programId={program.id} lists={lists} />
            </TabsContent>
            <TabsContent value="leaderboard">
              <TopShopLeaderboardTab programId={program.id} />
            </TabsContent>
            <TabsContent value="lists">
              <TopShopListsTab programId={program.id} lists={lists} />
            </TabsContent>
            <TabsContent value="sponsors">
              <TopShopSponsorsTab programId={program.id} />
            </TabsContent>
          </Tabs>
        )}
      </div>
    </DashboardLayout>
  );
}
